import React from 'react';

import { OnlineContractingStateEnum } from 'v3/data/store/onlineContracting/enums';
import { getFinancingStatusDetails } from 'v3/shared/components/Table/OnlineContractingTable/statusHelpers';
import { StatusDot, StatusValueContainer } from 'v3/shared/components/Table/styles';
import { SubtitleMedium } from 'v3/shared/typography/SubtitleMedium';

interface IFinancingStatusProps {
  contractingState: OnlineContractingStateEnum;
}

export const FinancingStatus: React.FC<IFinancingStatusProps> = ({ contractingState }) => {
  const { label, color } = getFinancingStatusDetails(contractingState);

  return (
    <StatusValueContainer>
      <StatusDot color={color} />
      <SubtitleMedium>{label}</SubtitleMedium>
    </StatusValueContainer>
  );
};
